// extracted by mini-css-extract-plugin
export var themeSwitcher = "theme-switcher-module--themeSwitcher--Aa0Uf";
export var switchToLight = "theme-switcher-module--switchToLight--3BRA3";
export var switchToDark = "theme-switcher-module--switchToDark--4m9Me";
export var indicator = "theme-switcher-module--indicator--9hJDj";